import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const CurrencyAnalysis = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default CurrencyAnalysis